import Vue from 'vue'

const DeliveryReservationTime = class {
  constructor({
 sortSequence, display, block, blockReason, availableTimeFrom, availableTimeTo 
}) {
    this.sortSequence = sortSequence
    this.display = display // 노출, 미노출
    this.block = block // 선택 가능, 선택 불가능
    this.blockReason = blockReason
    this.availableTimeFrom = availableTimeFrom // 2019-11-05T00:30:00
    this.availableTimeTo = availableTimeTo // 2019-11-05T00:30:00
  }

  get active() {
    return !this.block
  }

  get from() {
    return Vue.time(this.availableTimeFrom)
      .locale('ko')
      .format('HH:mm')
  }

  get to() {
    return Vue.time(this.availableTimeTo)
      .locale('ko')
      .format('HH:mm')
  }

  get fromHour() {
    return Number(
      Vue.time(this.availableTimeFrom)
        .locale('ko')
        .format('HH')
    )
  }

  get fromMinute() {
    return Number(
      Vue.time(this.availableTimeFrom)
        .locale('ko')
        .format('mm')
    )
  }

  get toHour() {
    return Number(
      Vue.time(this.availableTimeTo)
        .locale('ko')
        .format('HH')
    )
  }

  get toMinute() {
    return Number(
      Vue.time(this.availableTimeTo)
        .locale('ko')
        .format('mm')
    )
  }
}

export default null

export const ofDeliveryReservationTime = (params = {}) => new DeliveryReservationTime(params)
